import React from 'react'
import groupBy from '@/util/groupBy'
import styled from '@emotion/styled'
import Alternativa from '../Alternativas/Alternativa'
import colorCalc from '@/util/colorCalc'
import { PeopleIcon } from '@primer/octicons-react'

const Barra = ({ title, obj, campo, alternativas, colors }) => {
  // console.log('obj', obj)
  // console.log('campo', campo)
  // console.log('keys', Object.keys(obj))
  const keys = Object.keys(obj)
  const orderedKeys = keys.sort((a, b) => {
    return obj[b].length - obj[a].length
  })
  return (
    <div className="barra">
      <h4 className="text-2xl font-bold">{title}</h4>
      <div>
        {orderedKeys.map(key => (
          <SubBarra
            key={key}
            mayor={obj[orderedKeys[0]].length}
            barraTitle={key}
            barraObj={obj[key]}
            campo={campo}
            alternativas={alternativas}
            colors={colors}
          />
        ))}
      </div>
    </div>
  )
}

const SubBarra = ({
  barraTitle,
  barraObj,
  campo,
  alternativas,
  colors,
  mayor,
}) => {
  // console.log('barraObj', barraObj)
  // console.log('campo', campo)
  const byAnswer = groupBy(barraObj, campo)
  const byAnswerArray = alternativas.map(answer => {
    return {
      name: answer === 'undefined' ? 'No respondió' : answer,
      quantity: byAnswer[answer] ? byAnswer[answer].length : 0,
    }
  })
  // console.log('byAnswerArray', byAnswerArray, byAnswerArray)
  // console.log('byAnswer', byAnswer)

  return (
    <div className="grid-cols-12 gap-2 sm:grid">
      <div className="block col-span-2 mt-1 text-base leading-none text-left sm:col-span-3 sm:text-right sm:text-lg">
        {barraTitle}
        <br />
        <small className="inline-block px-2 py-1 font-sans text-xs font-bold bg-gray-400 rounded-full ">
          <PeopleIcon size={13} /> {barraObj.length}
        </small>
      </div>
      <div className="block col-span-10 sm:col-span-9">
        <WrapBar style={{ width: ` ${10 + (barraObj.length / mayor) * 90}%` }}>
          {byAnswerArray.map((answer, index) => (
            <Alternativa
              key={answer.name}
              index={index}
              mode="bar"
              porcion={answer.quantity}
              total={barraObj.length}
              color={
                answer.name === 'No respondió'
                  ? '#ccc'
                  : colorCalc(index, campo.replace('_', ''), colors)
              }
            />
          ))}
        </WrapBar>
        <div className="text-left">
          {byAnswerArray.map((answer, index) => (
            <div
              key={answer.name}
              className="inline-block mr-4 font-sans text-xs">
              <strong>{String.fromCharCode(97 + index)}.</strong>{' '}
              {((answer.quantity / barraObj.length) * 100)
                .toFixed(1)
                .replace(/[.,]0$/, '')}
              %
              {answer.quantity > 0 && (
                <>
                  {' '}
                  <span
                    className="bg-gray-400"
                    style={{ padding: '1px 2px', borderRadius: '6px' }}>
                    (
                    <PeopleIcon size={13} />
                    {answer.quantity})
                  </span>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Barra

const WrapBar = styled.div`
  display: flex;
  border-radius: 3px;
  border: 1px solid black;
  box-shadow: 3px 4px 0 0 black;
  margin-bottom: 0;
  min-height: 3rem;
`
